export const pedestrianTypes = {
    GET_MY_PRODUCTS_PEDESTRIAN_RIGHTS: "GET_MY_PRODUCTS_PEDESTRIAN_RIGHTS",
    GET_PEDESTRIAN_PRODUCTS: "GET_PEDESTRIAN_PRODUCTS",
    CLEAR_DELEGEE_DETAILS: "CLEAR_DELEGEE_DETAILS",
    DISPOSE_ERROR: "DISPOSE_ERROR",
    INVITE_DELEGEE: "INVITE_DELEGEE",
    REVOKE_PEDESTRIAN_RIGHTS: "REVOKE_PEDESTRIAN_RIGHTS",    
    DELETE_PEDESTRIAN_DELEGEES: "DELETE_PEDESTRIAN_DELEGEES",
    TOGGLE_SHOW_REVOKE_PEDESTRIAN: "TOGGLE_SHOW_REVOKE_PEDESTRIAN",
    RESEND_INVITE: "RESEND_INVITE",
    GET_PEDESTRIAN_DELEGEE: "GET_PEDESTRIAN_DELEGEE",
    UPDATE_DELEGEE: "UPDATE_DELEGEE",
    SELECT_PEDESTRIAN_ID_TO_EDIT: "SELECT_PEDESTRIAN_ID_TO_EDIT",
    TOGGLE_SHOW_DELETE_PEDESTRIAN_DELEGEES: "TOGGLE_SHOW_DELETE_PEDESTRIAN_DELEGEES",
    GET_PEDESTRIAN_DELEGEES_MYFLEET: "GET_PEDESTRIAN_DELEGEES_MYFLEET",
    GET_PARKING_PRODUCTS: "GET_PARKING_PRODUCTS",
} as const;